import Vue from "vue";
import VueRouter from "vue-router";

import bookingEdit from "../components/bookingEdit.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "widget",
    component: bookingEdit,
    props: route => ({
      companyId: route.query.companyId,
      activeBranch: route.query.activeBranch,
      salonhubname: route.query.sh,
      lang: route.query.lang,
      gender: route.query.gender,
      clientIntel: route.query.ci,
      clientOrder: route.query.cio,
      treatmentByParam: route.query.shtm,
      clientName: route.query.shname,
      clientEmail: route.query.shem,
      clientTel: route.query.shtel,
      showPrice: route.query.shp,
      src: route.query.src
    }),
    meta: {
      title: "Widget - Pillarrr"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
